import KoreaFood from 'assets/image/SurveyFood/KoreaFood.png';
import ChinaFood from 'assets/image/SurveyFood/ChinaFood.png';
import JapanFood from 'assets/image/SurveyFood/JapanFood.png';
import UsFood from 'assets/image/SurveyFood/UsFood.png';

const SurveyFoodData = [
  {
    id: 1,
    img: KoreaFood,
    text: '한식',
    english: 'KOREAN'
  },
  {
    id: 2,
    img: ChinaFood,
    text: '중식',
    english: 'CHINESE'
  },
  {
    id: 3,
    img: JapanFood,
    text: '일식',
    english: 'JAPANESE'
  },
  {
    id: 4,
    img: UsFood,
    text: '양식',
    english: 'WESTERN'
  }
];

export default SurveyFoodData;
